import GeneralModal from '../GeneralModal/GeneralModal'
import Modal from 'react-modal'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import { useCreatePaymentMutation, useSubscriptionQuery } from '../../api/api'
import LoadingBlocker from '../LoadingSpinner/LoadingBlocker'
import dayjs from 'dayjs'
import useIsSubscribed from '../../utils/hooks/useIsSubscribed'
import SubscriptionOptions from './SubscriptionOptions'

const SubscriptionRequiredModal = ({ isOpen }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {}}
      className="modal w-[775px]"
      overlayClassName="modal-overlay"
    >
      <div className="p-12 rounded-t relative min-h-[300px]">
        <div className="text-lg text-white-dark font-body font-semibold mb-1">
          Subscription expired{' '}
        </div>
        <div className="font-heading font-bold  text-4xl">
          Renew your subscription to continue using{' '}
          <span className="text-salmon">Sharefolio</span>
        </div>
        <div className="mt-8">
          <p className="mb-1">
            Your web players and portfolios will continue to work as normal but
            you are unable to make any changes until you renew your
            subscription.
          </p>
        </div>
        <div className=" mt-10">
          <SubscriptionOptions buttonLabel="Renew Subscription" />
        </div>
      </div>
    </Modal>
  )
}

const Notch = () => (
  <span className="inline-block mr-2 bg-white-dark rounded-full h-[5px] w-[5px]"></span>
)

export default SubscriptionRequiredModal
